import { Chain, WalletType } from '@web3/base-utils';
import { ActionsRes } from '@/services';
export interface activityInfo {
  activityDesc: string;
  activityDetail: string;
  activityDisclaimer: string;
  activityIconUrl: string;
  activityId: number;
  activityName: string;
  activityStatus: number;
  activitySubtitle: string;
  activityTag: number;
  activityTitle: string;
  activityType: number;
  appGoUrl: string;
  bizIconUrl: string;
  bizName: string;
  name: string;
  chainId: number;
  clientConfig?: {
    pcConfig: {
      support: boolean;
      versionLimit: string;
    };
  };
  endTime: number;
  isHidden: boolean;
  mediaUrl: string;
  rewardDesc: string;
  rewardInfos: {
    amount: number | string;
    symbol: string;
    icon: string;
  }[];
  rewardPoolDetail: string;
  startTime: number;
  webGoUrl: string;
  webBgBanner: string;
  webShareImg: string;
  appBgBanner: string;
  landingBanner: string;
  landingBannerGo: string;
  participants: number;
  taskCnt: number;
  activityTags: string[];
  walletTypeList: WalletType[];
  website: string;
}

export interface activityDetailRes {
  code: number;
  message: string;
  success: boolean;
  result: activityDetail;
}

export interface activityDetail {
  activityInfo: activityInfo;
  rewardInfo: rewardInfo[];
  taskNum: number;
}
export interface pageBase {
  pageNo: number;
  pageSize: number;
}

export interface pageInfo extends pageBase {
  totalNum: number;
  totalPage: number;
}

export interface rewardContent {
  amount: number;
  chainCode: number;
  contractAddress: string;
  symbol: string;
}

export enum RewardFormType {
  Delay = 4,
}

export interface rewardInfo {
  appGoUrl: string;
  detail: string;
  iconUrl: string;
  mysteryBoxRewards: { name: string; iconUrl: string }[];
  name: string;
  rewardContent: rewardContent;
  rewardForm: RewardFormType;
  rewardName: string;
  recordCreatedAt: number;
  rewardId: number;
  rewardType: number;
  webGoUrl: string;
  status: number;
}

export interface ruleInfo {
  appTargetUrl: string;
  depositChainCode: number;
  depositContract: string;
  depositSymbol: string;
  detail: string;
  iconUrl: string;
  order: number;
  ruleType: number;
  socialMediaId: number;
  socialMediaName: string;
  socialMediaType: number;
  status: number;
  title: string;
  webTargetUrl: string;
}

export interface taskRuleConfig {
  ruleList: ruleInfo[];
  tutorialUrl: string;
}

export interface subTaskListItem {
  appGoUrl: string;
  configId: number;
  endTime: number;
  recordId: number;
  startTime: number;
  status: number;
  taskDesc: string;
  taskName: string;
  taskRuleConfig: string;
  taskType: number;
  webGoUrl: string;
  mediaAuthorized: boolean;
}

export interface InviteDTO {
  rankInfo: {
    validInvitations: number;
    userRanking: string;
  };
}

export interface taskDetail {
  activityId: number;
  appGoUrl: string;
  bizIconUrl: string;
  bizName: string;
  claimType: number;
  chainId?: number;
  configId: number;
  displayOnly: boolean;
  endTime: number;
  hasQualified: false;
  hasSnapshot: false;
  participants: number;
  recordId: number;
  rewardActiveAmount: number;
  rewardDesc: string;
  rewardList: rewardInfo[];
  rewardLockAmount: number;
  rewardTotalAmount: number;
  snapshotEndTime: number;
  snapshotMinAsset: number;
  snapshotStartTime: number;
  snapshotType: number;
  startTime: number;
  status: number;
  subTaskList: subTaskListItem[];
  taskDesc: string;
  taskDetail: string;
  taskIconUrl: string;
  taskName: string;
  taskType: number;
  webGoUrl: string;
  taskRuleConfig: string; //taskRuleConfig
  inviteTaskDTO: InviteDTO;
}

export enum RewardClaimType {
  AUTO = 0,
  MANUAL = 1,
}

export enum RewardClaimStatus {
  AWAIT = 1,
  CLAIM = 2,
  FINISH = 3,
  EXPIRE = 4,
}

export interface rewardListItem {
  activityTitle: string;
  appGoUrl: string;
  taskName: string;
  claimAt: number;
  rewardContent: string;
  rewardId: number;
  chainId: number;
  rewardRecordId: number;
  rewardSymbol: string;
  rewardType: number;
  claimType: number;
  webGoUrl: string;
  rewardClaimType: RewardClaimType;
  claimCode: string;
  rewardClaimStatus: RewardClaimStatus;
  claimStartTime: number;
  claimEndTime: number;
  blocked: boolean;
}

export interface Pagination<T> {
  total: number;
  list: T[];
}

export interface taskCheckRes {
  checkResult: boolean;
  isTokenExpired: boolean;
}

export interface rewardInfoRes {
  rewardContent: string;
  rewardIconUrl: string;
  rewardId: number;
  rewardSymbol: string;
  rewardType: number;
}
export interface rewardClaimRes {
  rewardInfo: rewardInfoRes;
  rewardStatus: number;
}

export interface RankDTO {
  iconUrl: string;
  ranking: number;
  userId: string;
  validInvitations: number;
  walletAddress: string;
}

export interface InviteCode {
  code: string;
}

export interface ShortLinkRes {
  code: number;
  message: string;
  tinyUrl: string;
  originalUrl: string;
}

export interface TaskListRes {
  code: number;
  message: string;
  success: boolean;
  result: taskDetail[];
}

export interface walletChains {
  CLOUD: { itemList: Chain[] };
  MNEMONIC_PHRASE: { itemList: Chain[] };
  // MPC: { itemList: Chain[] };
}

export interface ChainListRes {
  code: number;
  message: string;
  success: boolean;
  result: { walletChains: walletChains };
}

export type BlinkData = ActionsRes & {
  blinksUrl: string;
};

//活动标签（0-全部，1-常规活动，2-空投活动，3-AirDrop Hunter, 4-Daily Reward）
export enum ActivityTag {
  all = 0,
  task = 1,
  airdrop = 2,
  hunter = 3,
  dailyReward = 4,
}
// 活动状态（0-全部，1-即将开始，2-进行中，3-已结束）
export enum ActivityStatus {
  all = 0,
  upcoming = 1,
  progress = 2,
  ended = 3,
}

// 活动类型 1-普通活动 2- swap交易挖矿每日任务活动 3-邀请活动  4-交易赛活动，任务无完成态
export enum ActivityType {
  normal = 1,
  dailyDraw = 2,
  invitation = 3,
  noStatus = 4,
}

//-1用户无法领取到任务 0-任务未完成 1-任务完成，奖励待领取 2-奖励已领取 3-领取失败 4-奖励达上限，5领取失败-无资格领取，6，分批领取，发放中, 100 任务已结束
export enum TaskStatus {
  unApply = -1,
  unComlete = 0,
  comleted = 1,
  claimed = 2,
  claimFaild = 3,
  rewardTop = 4,
  unqualified = 5,
  issuing = 6,
  ended = 100,
}

/**
 *  任务类型：
 *  1: APEX_EXPERIENCE_MONEY 2，ido的快照任务 3,展示到六任务，4交互任务，5，staking任务，6swap任务，7swap子任务，8签到任务，100 父任务，101 充值任务，
 *  目前airdrop用到的如下：
 *  102 社媒任务，103 dapp任务, 111 swap任务  112 dexpro任务 113 blink任务
 */
export enum SubTaskType {
  deposit = 101,
  media = 102,
  dapp = 103,
  swap = 111,
  dexPro = 112,
  blink = 113,
  click = 114,
}

//奖励状态：0 未领奖，1 已领奖，2 未获奖， 3 已过期, 4 已中奖且已空投, 5 等待开奖
export enum RewardStatus {
  noClaim = 0,
  claimed = 1,
  noWin = 2,
  expired = 3,
  airdroped = 4,
  delay = 5,
}

// 奖励类型
export enum RewardType {
  token = 1, //
  nft = 2, //
  blindbox = 3, // 盲盒
  multiple = 4, // 复合型奖励
}

// prepare类型任务（原充值任务）
export enum PrepareTaskTypes {
  deposit = 101,
  swap = 110,
}
